export const getGermanWordWithoutArticle = word => {
  const wordSeparated = word.split(/der\s|die\s|das\s/i);
  return wordSeparated.length > 1 ? wordSeparated[1] : wordSeparated[0];
};



// WEBPACK FOOTER //
// ./src/helpers/index.js